import { render } from "./JobDetail.vue?vue&type=template&id=1c1ddc60"
import script from "./JobDetail.vue?vue&type=script&lang=js"
export * from "./JobDetail.vue?vue&type=script&lang=js"

import "./JobDetail.vue?vue&type=style&index=0&id=1c1ddc60&lang=css"

import exportComponent from "/Users/baldiph/Documents/Coding/Loxone/Loxone Jobs/wp-content/loxone/jobs-detail/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__